export const removeEmptyParams = (params: Record<string, unknown>) => {
    Object.entries(params).forEach(([key, value]) => {
        const isEmpty = (v: unknown) => v === null || v === undefined || v === '' || (typeof v === 'string' && v.trim() === '');
        
        if (isEmpty(value)) {
            delete params[key];
            return;
        }
        if (typeof value === 'string') {
            params[key] = value.trim();
            return;
        }
        if (Array.isArray(value)) {
            let hasEmpty = false;
            
            const trimmedArray = value.map(item => {
                if (isEmpty(item)) {
                    hasEmpty = true;
                    return item;
                }

                return typeof item === 'string' ? item.trim() : item;
            });

            if (hasEmpty) {
                delete params[key];
            } else {
                params[key] = trimmedArray;
            }
        }
    });
};
